var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 1.833a6.167 6.167 0 1 0 0 12.334A6.167 6.167 0 0 0 8 1.833M.833 8a7.167 7.167 0 1 1 14.334 0A7.167 7.167 0 0 1 .833 8m7.844 2.634V8.126a.672.672 0 1 0-1.344 0v2.508a.672.672 0 1 0 1.344 0m0-5.295v.418a.672.672 0 0 1-1.344 0v-.418a.672.672 0 0 1 1.344 0",
  clipRule: "evenodd"
})));
export default SvgInfoCircle;